// extracted by mini-css-extract-plugin
export default {"limit":"Footer_limit__4U5oV","copyright":"Footer_copyright__6LZBv","links":"Footer_links__iSTvQ"};